













import { Component, Vue, Prop } from 'vue-property-decorator';
import IssueItem from './issueItem.vue';
import MarkedText from '@/components/marked/markedText.vue';
import ListBox from '@/components/listBox/listBox.vue';

type IIssueInfo = IIssue.IResponse.IIssueInfo;

@Component({
  components: {
    IssueItem,
    MarkedText,
    ListBox,
  },
})
export default class IssueList extends Vue {
  @Prop({ required: true }) private spinning!: boolean;
  @Prop({ required: true, default: () => [] }) private data!: IIssueInfo[];
  @Prop({ default: '' }) private activeId!: string;
  private viewDetail(issue: IIssue.IResponse.IIssueInfo) {
    this.$emit('click', issue);
  }
}
